module.exports = __webpack_public_path__ + "2f847810090ed711b72af3e89efcaf05.png";